import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationUserAlbumDb = {
  userId: string;
  albumId: string;
  order: number;
}
const initial: RelationUserAlbumDb = {
  userId: '',
  albumId: '',
  order: 0
};

export type RelationUserAlbumDbHashType = {
  [key in string]: RelationUserAlbumDb;
}

export type RelationUserAlbumAddPayload = {
  id?: string;
} & RelationUserAlbumDb;
export type RelationUserAlbumUpdatePayload = {
  id: string;
} & { [P in keyof RelationUserAlbumDb]?: RelationUserAlbumDb[P] };

export type RelationUserAlbumDbState = {
  relationUserAlbums: RelationUserAlbumDbHashType;
}

export const generateRelationUserAlbumId = (): string => generateId('rua');
let initialState: RelationUserAlbumDbState = { relationUserAlbums: {} };
const key = 'relationUserAlbums';

const relationUserAlbumDbSlice = createSlice({
  name: 'relationUserAlbumDb',
  initialState,
  reducers: {
    initializeRelationUserAlbums(state: RelationUserAlbumDbState) {
      state.relationUserAlbums = {};
    },
    addRelationUserAlbum(state: RelationUserAlbumDbState, action: PayloadAction<RelationUserAlbumAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationUserAlbumId();
      state.relationUserAlbums[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationUserAlbum(state: RelationUserAlbumDbState, action: PayloadAction<RelationUserAlbumUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationUserAlbums[id] === undefined) {
        console.log(`*** RelationUserAlbum not found: ${id}`);
      } else {
        const newData = { ...state.relationUserAlbums[id], ...obj };
        state.relationUserAlbums[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationUserAlbum(state: RelationUserAlbumDbState, action: PayloadAction<RelationUserAlbumUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationUserAlbums[id];
      deleteData(key, id);
    },
    saveRelationUserAlbums(state: RelationUserAlbumDbState) {
      saveAllData(key, state.relationUserAlbums);
    },
    signUpRelationUserAlbums(state: RelationUserAlbumDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationUserAlbums, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationUserAlbumDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationUserAlbums = updatedValues;
      if (changed) saveAllData(key, state.relationUserAlbums);
    })
  }
})

export const { initializeRelationUserAlbums, addRelationUserAlbum, updateRelationUserAlbum, deleteRelationUserAlbum, saveRelationUserAlbums, signUpRelationUserAlbums } = relationUserAlbumDbSlice.actions;
export default relationUserAlbumDbSlice.reducer;
